var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Board',{attrs:{"title":"材料管理","hint":`待处理 ${_vm.pending}`,"icon":"/images/data-center-screen/boards/icon-materials.svg","sub-window":"materials"},on:{"sub-window":function($event){return _vm.$emit('sub-window', $event)}}},[_c('BoardStats',{attrs:{"title":"材料记录","before":"收录","n":_vm.n,"after":`份`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }